export default "__VITE_ASSET__BtfgiTTA__"